import React from "react";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import Header from "./Header";
import CategorySection from "./CategorySection";

import {
  useGetServicesQuery,
  useGetSliderPageQuery,
} from "../../store/Slice/rtk";

const DualPathSection = React.lazy(() => import("./DualPathSection"));
const CommentSection = React.lazy(() => import("./CommentSection"));
const NewJobRequest = React.lazy(() => import("./NewJobRequest"));
const AppDownloadSection = React.lazy(() => import("./AppDownloadSection"));

function LazySection({ children, minHeight }) {
  const ref = React.useRef(null);
  const [inView, setInView] = React.useState(false);

  React.useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "400px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={ref} sx={{ minHeight }}>
      {inView ? (
        <React.Suspense fallback={<Box sx={{ minHeight }} />}>
          {children}
        </React.Suspense>
      ) : null}
    </Box>
  );
}

export default function NewHome() {
  const { data, isLoading, isFetching, isError } = useGetSliderPageQuery();
  const {
    data: categoryData,
    isLoading: categoryLoading,
    isError: categoryError,
    isFetching: categoryFetching,
  } = useGetServicesQuery({
    filter: "level=0",
  });
  return (
    <>
      <Header
        sliderData={data}
        isLoading={isLoading}
        isFetching={isFetching}
        isError={isError}
      />
      <CategorySection
        categoryData={categoryData}
        categoryLoading={categoryLoading}
        categoryError={categoryError}
        categoryFetching={categoryFetching}
      />

      <LazySection minHeight={{ xs: 800, md: 640 }}>
        <DualPathSection />
      </LazySection>
      <LazySection minHeight={{ xs: 580, md: 600 }}>
        <NewJobRequest />
      </LazySection>
      <LazySection minHeight={{ xs: 650, md: 700 }}>
        <CommentSection />
      </LazySection>
      <LazySection minHeight={{ xs: 850, md: 750 }}>
        <AppDownloadSection />
      </LazySection>
    </>
  );
}
